import React, { useContext, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiGetCall, ApiPostCall } from '../JS/Connector';
import { AdminSchoolId, HideLoder, LogInSchoolID, LogInUserID, ShowLoder, typewatch } from '../JS/Common';
import AlertsComp from './AlertsComp';
import { UserContext } from '../App';
import { CheckValidation } from './Validations';
import UserDetailsPopup from './UserDetailsPopup';
import Deletepopup from './Deletepopup';
import AlertPopup from './AlertPopup';
import TicketDetailsPopup from './TicketDetailsPopup';
import { DeviceDetailsPopup } from './DeviceDetailsPopup';
import ReworkPopup from './ReworkPopup';
import SchoolProfileInfo from '../Layout/SchoolProfile/SchoolProfileInfo';
import { Accordion } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { hasRoleAccess, RoleEnum } from '../JS/RoleType';
import { doSort, findHighest, getBasePrice, getBillingColor, GetPricingDetailsPart, halfPrice, handleOnFocusChange, PriceReasonMap, PriceReasonResFun, savedBillingColorMap } from '../Helpers/BillingHelpers';
import useConfig from '../Hooks/useConfig';
import CustomFieldInfoIcon from './CustomFieldInfoIcon';

function RepairDetails() {
    const { organization, show_device_complete_club, student, organization_part, adminCallNode, dcc_module_text } = useConfig();
    const navigate = useNavigate();
    const location = useLocation();
    const TicketId = location.state && location.state.tabTicketId;
    const ticketTabFlag = location.state && location.state.ticketTabFlag;
    const workedonflag = location.state && location.state.workedonflag;
    const tabflag = location.state && location.state.tickettabflag;
    const schoolIdForAdmin = location.state && location.state.schoolid;
    const billingflag = location.state && location.state.billingflag;
    const FlagForParental = location.state && location.state.parentalCoverageFlag;
    const RepairStatus = location.state && location.state.RepairStatus;
    const [SuggestionBoxArray, setSuggestionBoxArray] = useState([]);
    const [repairFinished, setRepairFinished] = useState(false);
    const [MarkasCloseTicket, setMarkasCloseTicket] = useState('');
    const [MarkasIncompleteRepair, setMarkasIncompleteRepair] = useState(RepairStatus == 1 ? 1 : 0);
    const [isTicketDetailspopup, setisTicketDetailspopup] = useState(false);
    const [DevicePopup, setDevicePopup] = useState(false);
    const [ReworkFlag, setReworkFlag] = useState(0);
    const suggestionBoxWhoWorkOnRef = useRef(null);
    const suggestionBoxRef = useRef(null);
    const [TicketData, setTicketData] = useState({
        TicketId: '',
        ShowSuggestion: 'd-none',
        RepairCharge: '',
        flag: 0,
        partDeleteFlag: 0
    });
    const [RepairNotes, setRepairNotes] = useState('')
    const [InventoryId, setInventoryId] = useState('')
    const [TicketSerialNum, setTicketSerialNum] = useState({
        SerialNum: "",
        TicketNum: "",
        Userid: ''
    })
    const [UserName, setUserName] = useState("")
    const [selectDamageId, setSelectDamageId] = useState(0);
    const [selectDeviceId, setSelectDeviceId] = useState(0);
    const [DeviceTypeCode, setDeviceTypeCode] = useState(0);
    const [NewAlerts, setNewAlerts] = useState("");
    const [SearchForParts, setSearchForParts] = useState("");
    const [loading, setLoading] = useState(false);
    const { UserData } = useContext(UserContext);
    const [DeviceTypes, setDeviceTypes] = useState([]);
    const [DamangeTyppe, setDamangeTyppe] = useState([]);
    const [TicketStatus, setTicketStatus] = useState('');
    const [SearchForWhoWorkOn, setSearchForWhoWorkOn] = useState('')
    const [ShowSuggestionForWhoWorkOn, setShowSuggestionForWhoWorkOn] = useState('d-none')
    const [ConfirmationModal, setConfirmationModal] = useState(false);
    const [ConfirmationCancelModal, setConfirmationCancelModal] = useState(false);
    const [UserModal, setUserModal] = useState(false);
    const [NumberOfClaim, setNumberOfClaim] = useState('')
    const [BillableFlag, setBillableFlag] = useState('');
    const [deletePopup, setDeletePopup] = useState(false);
    const [deletepartid, setdeletepartid] = useState('');
    const [deletepartbuildingid, setdeletepartbuildingid] = useState('');
    const loggedinemailid = UserData.emailid;
    const [RepairLoder, setRepaiLoder] = useState(false);
    const [EnrollmentHistory, setEnrollmentHistory] = useState([]);
    const [ReworkModal, setReworkModal] = useState(false);
    const [ReworkMsg, setReworkMsg] = useState('');
    const [RepairTypeMsg, setRepairTypeMsg] = useState('');
    const [MarkasRepair, setMarkasRepair] = useState('');
    const [underWarrantyChecked, setUnderWarrantyChecked] = useState(0);
    const [originalDeviceType, setOriginalDeviceType] = useState(null);
    const [originalParts, setOriginalParts] = useState(null);
    const [RepairSectionAddUpdateFlag, setRepairSectionAddUpdateFlag] = useState(0);
    const [ReworkTicketWhoWorkOn, setReworkTicketWhoWorkOn] = useState("");
    const [selectedTechnician, setSelectedTechnician] = useState([]);
    const [TechnicianData, setTechnicianData] = useState({
        data: [],
        loader: false
    });
    const [activeKey, setActiveKey] = useState(null);
    const [GetDataStored, setGetDataStored] = useState([])
    const [TechPointsAgreeFlag, setTechPointsAgreeFlag] = useState(1);
    const [selectedDiscountFlag, setSelectedDiscountFlag] = useState(2);
    const [ticketParts, setTicketParts] = useState([]);
    const [showUnderWarranty, setShowUnderWarranty] = useState(false);
    const seeMoreFlag = useRef(0);
    const [SchoolCustomPriceParts, setSchoolCustomPriceParts] = useState({
        schoolHalvedFlag: 2,
        customPricingParts: null
    });
    const [deviceModelState, setDeviceModelState] = useState({
        deviceModel: "",
        deviceManufacturer: "",
        isApproveModel: false
    });

    const reworkFlagRef = useRef(null);
    const priceOnFocusRef = useRef(null);
    const partCoveredColorMap = {
        1: 'highlight-part',
        2: 'redText',
        3: 'blueText'
    };

    const effectiveRole = UserData.copyrole || UserData.role || null;
    const WhoWorkedOnAccess = hasRoleAccess(effectiveRole, RoleEnum.WHO_WORKED_ON);
    const ExcludeVarAccess = hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_VAR);

    function calculatePartPrice(discountRepairTypeFlag, originalPrice, customPrice) {
        const hasCustom = customPrice != null;
        const base = Number(originalPrice || 0);
        const custom = Number(customPrice);
        const resPrice = hasCustom ? custom : base;
        if (workedonflag == 1) {
            if (discountRepairTypeFlag == 2 && SchoolCustomPriceParts.schoolHalvedFlag == 2) return PriceReasonResFun(resPrice, hasCustom ? PriceReasonMap.CustomVal : PriceReasonMap.NoChangesVal); // BOTH 2 no halving at all
            if (SchoolCustomPriceParts.schoolHalvedFlag == 1) return PriceReasonResFun(halfPrice(resPrice), hasCustom ? PriceReasonMap.CustomHalvedVal : PriceReasonMap.HalvedVal); // 50% School Side discount
            if (discountRepairTypeFlag == 1) return PriceReasonResFun(halfPrice(resPrice), hasCustom ? PriceReasonMap.CustomHalvedVal : PriceReasonMap.HalvedVal); // 50% Repair Type discount
        }
        return PriceReasonResFun(resPrice, hasCustom ? PriceReasonMap.CustomVal : PriceReasonMap.NoChangesVal); // If none
    }

    function isZeroPrice(item) {
        if ([1, 2, 3]?.includes(item.partCoveredBy)) return true
        if (item.warrantyCheckbox == true) return true;
        if (reworkFlagRef.current == 1 && item.addUpdateFlag == 0) return true;
        if (ReworkFlag == 1) {
            if (reworkFlagRef.current == 2 && item.addUpdateFlag == 0) return false;
            return true;
        }
        if (FlagForParental == 1) {
            if (EnrollmentHistory?.enrollment_status == 2) return false;
            return true;
        }
        return false;
    }

    function handleExceptionalCases(part) {
        if (part.isPriceLocked) return true;
        if (part.price_correction_reason == PriceReasonMap.ManualVal) return true;
        if (part.flag === 'schoolColorStatus') return true;
        return false
    }

    function applyPricingRule(list, discountRepairTypeFlag, toggledPartId) {
        if (!list?.length) return list;
        const customPriceMap = SchoolCustomPriceParts.customPricingParts
        const highest = findHighest(list, customPriceMap, toggledPartId, "variantPriceValue", "originalPrice", isZeroPrice);
        const priced = list.map(item => {
            if (handleExceptionalCases(item)) return item; // Don't apply pricing for exceptional cases
            if (isZeroPrice(item)) return { ...item, variantPriceValue: 0, price_correction_reason: PriceReasonMap.ZeroVal }; // Warranty, Rework, Parental Flag
            const base = getBasePrice(item, customPriceMap, "variantPriceValue", "originalPrice");
            if (highest && item.id === highest.id) return { ...item, variantPriceValue: base?.price, price_correction_reason: customPriceMap[item.id] ? PriceReasonMap.CustomVal : PriceReasonMap.HighestVal }; // highest part check
            const PriceReason = calculatePartPrice(discountRepairTypeFlag, base?.price, customPriceMap[item.id])
            return { ...item, variantPriceValue: PriceReason.price, price_correction_reason: PriceReason.reason };
        });
        return doSort(priced, "variantPriceValue");
    }

    useEffect(() => {
        if (hasRoleAccess(effectiveRole, RoleEnum.ONLY_REPAIR_TECH)) {
            setActiveKey("0");
        } else {
            if (RepairSectionAddUpdateFlag == 1) {
                setActiveKey("0");
            }
        }
    }, [RepairSectionAddUpdateFlag]);

    useEffect(() => {
        if (workedonflag == 1) {
            GetAllDeviceType();
            GetSelectedTechnician();
        }
        if (workedonflag == 1) {
            var Schoolid = schoolIdForAdmin
        } else {
            var Schoolid = LogInSchoolID
        }
        GetPricingDetailsPart(Schoolid, setLoading, setSchoolCustomPriceParts);
        GetAllDamangeType();
        GetTicketDataByID();
        const handleClickOutside = (event) => {
            if (suggestionBoxRef.current && !suggestionBoxRef.current.contains(event.target) && event.target.id !== 'partsSearchInput') {
                setTicketData({ ...TicketData, ShowSuggestion: "d-none" });
                seeMoreFlag.current = 0;
            }
        };
        const handleClickOutsideWhoWorkOn = (event) => {
            if (suggestionBoxWhoWorkOnRef.current && !suggestionBoxWhoWorkOnRef.current.contains(event.target)) {
                setShowSuggestionForWhoWorkOn('d-none')
            }
        };
        const handleWindowClick = (event) => {
            handleClickOutside(event);
            handleClickOutsideWhoWorkOn(event);
        };
        window.addEventListener('click', handleWindowClick);
        return () => {
            window.removeEventListener('click', handleWindowClick);
        };
    }, []);
    async function GetRepairParts(searchString) {
        if (searchString?.trim() == "" || searchString == undefined) {
            setTicketData({ ...TicketData, ShowSuggestion: 'd-none' });
            searchString = null;
        } else {
            searchString = searchString?.trim();
        }
        if (workedonflag == 1) {
            var Schoolid = schoolIdForAdmin
        } else {
            var Schoolid = LogInSchoolID
        }
        setTicketData({ ...TicketData, ShowSuggestion: '' });
        setRepaiLoder(true)
        typewatch(async function () {
            if (workedonflag == 1) {
                var result = await ApiGetCall(`${adminCallNode}/parts/all?search=${searchString}&ticketId=${TicketId}&seeMore=${seeMoreFlag.current || 0}`);
            } else {
                var result = await ApiGetCall(`/parts/all?schoolId=${Schoolid}&search=${searchString}&ticketId=${TicketId}&seeMore=${seeMoreFlag.current || 0}`);
            }
            if (!result) {
                alert("Something went wrong");
                setLoading(false);
                return;
            }
            setLoading(false);
            setRepaiLoder(false)
            const responseRs = JSON.parse(result);
            const vDataIds = new Set(ticketParts.map(p => p.id));
            const sugData = responseRs?.msg?.filter(item => !vDataIds.has(item.id));
            var vHtml = "";

            const vSeeMore = (
                <div className={` row brdr-Btm font-14 cursor-pointer p-Suggestion ${seeMoreFlag.current == 1 ? 'd-none' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        seeMoreFlag.current = 1;
                        GetRepairParts(SearchForParts);
                    }}>
                    <div className="col-12 text-center cursor-pointer">
                        <label className='cursor-pointer text-decoration-underline'>Show All Manufacturer Parts</label>
                    </div>
                </div>
            )

            if (sugData.length != 0) {
                var vArray = [];
                for (var i = 0; i < sugData.length; i++) {
                    if (workedonflag == 1) {
                        vHtml =
                            <div className={`row brdr-Btm font-14 schoolid cursor-pointer p-Suggestion ${getBillingColor(sugData[i], SchoolCustomPriceParts.customPricingParts)} ${sugData[i].flag}`}
                                onClick={(e) => showpartsdetails(e)} dataid={sugData[i].id}>
                                <div className="col-9 text-start">
                                    <b>{sugData[i].title}</b>
                                </div>
                                <div className="col-3 text-end font-13 vl">Master Part</div>
                                <div className='col-12 font-12'>
                                    NetSuite SKU : {sugData[i].netsuite_internal_sku || '-'}
                                </div>
                            </div>
                    } else {
                        vHtml = responseRs.master_inventory_flag == 1 ?
                            <div className={`row brdr-Btm font-14 schoolid cursor-pointer p-Suggestion ${sugData[i].flag}`} onClick={(e) => showpartsdetails(e)} dataid={sugData[i].id}>
                                <div className="col-9 text-start">
                                    <b>{sugData[i].title}</b>
                                </div>
                                {sugData[i].school_id == null ?
                                    <div className="col-3 text-end font-13 vl">Master Part</div>
                                    :
                                    <div className="col-3 text-end font-13 vl">{organization_part}</div>
                                }
                            </div>
                            :
                            <>
                                {sugData[i].school_id !== null && (
                                    <div className={`row brdr-Btm font-14 schoolid cursor-pointer p-Suggestion ${sugData[i].flag}`} onClick={(e) => showpartsdetails(e)} dataid={sugData[i].id}>
                                        <div className="col-9 text-start">
                                            <b>{sugData[i].title}</b>
                                        </div>
                                        <div className="col-3 text-end font-13 vl">{organization_part}</div>
                                    </div>
                                )}
                            </>
                    }
                    vArray.push(vHtml);
                }

                if (responseRs.is_see_more) {
                    vArray.push(vSeeMore);
                }
                setSuggestionBoxArray(vArray);
            } else {
                var vArray = [];
                vHtml = (
                    <div className="col-12 text-center">
                        <label>No Record Found</label>
                    </div>
                );
                vArray.push(vHtml);

                if (responseRs.is_see_more) {
                    vArray.push(vSeeMore);
                }

                setSuggestionBoxArray(vArray);
            }
        }, 1000);
    };
    async function showpartsdetails(e) {
        setLoading(true);
        var dataID = e.currentTarget.attributes[1].value;
        setSearchForParts('')
        await ApiGetCall(`/parts/by-id?uuid=${dataID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setTicketData({ ...TicketData, ShowSuggestion: 'd-none' });
                const responseRs = JSON.parse(result);
                AddNewRow(responseRs);
            }
        });
    }
    function handleDelete(id) {
        setLoading(true);
        const vFinalId = id.split('_')[1];
        const updatedData = ticketParts.filter((row) => {
            if (row.props && row.props.id) {
                return row.props.id !== vFinalId;
            }
            return row.id != vFinalId;
        });
        setTimeout(() => {
            handlePriceCalculation(updatedData);
            setLoading(false);
        }, 500);
    }
    async function SaveRepairParts(e, fromDelete = false, partsOverride = null) {
        const sourceParts = partsOverride ?? ticketParts;
        const updatedPartNotesArray = [];
        sourceParts?.filter(item => item.addUpdateFlag == 1)?.forEach(item => {
            const finalPartId = item.id;
            const notes = document.getElementById(`NotesId_${finalPartId}`).value;
            const price = fromDelete ? item.variantPriceValue : document.getElementById(`PartsPrice_${finalPartId}`).value;
            const partflag = item.part_flag;
            const partCoverBy = item.partCoveredBy;
            updatedPartNotesArray.push({
                PartID: finalPartId,
                Notes: notes ? notes : null,
                Price: price ? price : 0,
                PartFlag: partflag,
                PartCoverBy: partCoverBy,
                Building_id: item.building_id ? item.building_id : null,
                PriceCorrectionReason: item.price_correction_reason,
            });
        });
        const actionArray = [];
        let totalPriceSum = 0;
        ticketParts?.filter(item => item.addUpdateFlag == 0)?.map((item) => {
            const vid = item.id;
            const warrantyCheckbox = document.querySelector(`#WarrantyCheckbox_${vid}`);
            const warrantyFlag = warrantyCheckbox ? (warrantyCheckbox.checked ? 1 : 0) : null;
            var PartCoverFlag = null
            if (warrantyFlag == 1 && ReworkFlag == 1) {
                PartCoverFlag = 3;
            } else if (warrantyFlag == 0 && ReworkFlag == 1) {
                PartCoverFlag = 2;
            } else if (warrantyFlag == null && ReworkFlag == 1) {
                PartCoverFlag = 2;
            } else if (warrantyFlag == 1 && ReworkFlag == 0) {
                PartCoverFlag = 1;
            } else if (warrantyFlag == 0 && ReworkFlag == 0) {
                PartCoverFlag = 0;
            } else if (warrantyFlag == null && ReworkFlag == 0) {
                PartCoverFlag = null;
            }
            var vjson = {};
            vjson['Notes'] = document.querySelector(`#NotesId_${vid}`).value;
            vjson['PartID'] = document.querySelector(`#hdnPartId_${vid}`).value;
            vjson['Price'] = document.querySelector(`#PartsPrice_${vid}`).value;
            vjson['PartFlag'] = item.flag === "schoolColorStatus" ? 2 : 1;
            vjson['PartCoverBy'] = PartCoverFlag;
            vjson['Building_id'] = item.building == "AtSchool" ? null : item.building || null;
            vjson['PriceCorrectionReason'] = item.price_correction_reason;
            totalPriceSum += vjson['Price'];
            actionArray.push(vjson);
        });

        const mergedArray = doSort(updatedPartNotesArray.concat(actionArray), "variantPriceValue");

        var flagForAdminAndSchool = 0
        if (workedonflag == 1) {
            var Schoolid = schoolIdForAdmin;
            var flagForAdminAndSchool = 1
        } else {
            var Schoolid = LogInSchoolID;
            var flagForAdminAndSchool = 2
        }

        const repairfinishflag = repairFinished ? 1 : 0;
        const MarkAsCloseflag = MarkasCloseTicket ? 1 : 0;
        const currentDeviceType = selectDeviceId;
        const deviceTypeChanged = originalDeviceType !== null && currentDeviceType !== originalDeviceType;
        const originalPartIds = originalParts ? originalParts.map(p => p.PartID) : [];
        const newPartIds = ticketParts?.filter(p => p.addUpdateFlag == 0)?.map(p => parseInt(document.querySelector(`#hdnPartId_${p.id}`).value));
        const anyNewPartAttached = newPartIds.some(id => !originalPartIds.includes(id));
        const TechnicianIds = selectedTechnician?.map(item => item.tech_id)
        const GetCallRepairFlag = GetDataStored.Status == 'Repair Finished' && 1
        const conditionsMet = [
            deviceTypeChanged,
            anyNewPartAttached,
            RepairNotes != '' && RepairNotes != GetDataStored?.ticket_repair_log[0]?.repaired_item,
            repairfinishflag == 1 && repairfinishflag != GetCallRepairFlag
        ].filter(Boolean).length;

        var TechArray = []
        if (workedonflag == 1) {
            TechArray = WhoWorkedOnAccess ? TechnicianIds.length > 0 ? TechnicianIds : [] : [LogInUserID]
        } else {
            TechArray = WhoWorkedOnAccess ? TechnicianIds.length > 0 ? TechnicianIds : [LogInUserID] : [LogInUserID]
        }
        var raw = JSON.stringify({
            schoolId: Schoolid,
            loginUserId: LogInUserID,
            ticketId: TicketId,
            repairedItem: RepairNotes,
            damageTypeId: selectDamageId,
            deviceTypeId: selectDeviceId,
            parts: mergedArray,
            flag: flagForAdminAndSchool == 2
                ? flagForAdminAndSchool
                : WhoWorkedOnAccess ? flagForAdminAndSchool : 2,
            repairFinished: repairfinishflag,
            markAsCloseflag: MarkAsCloseflag,
            technicianOrAdminIds: TechArray,
            markAsRework: MarkasRepair,
            markasIncompleteRepair: MarkasIncompleteRepair,
            attachedPointFlag: flagForAdminAndSchool == 2
                ? (deviceTypeChanged || anyNewPartAttached ? 1 : 0)
                : conditionsMet >= 3 ? 1 : 0,
            repairSectionAddUpdateFlag: RepairSectionAddUpdateFlag == 1 ? 0 : 0,
            reworkTicketWhoWorkOnId: ReworkTicketWhoWorkOn || null,
            tech_repair_log: {
                WhoWorkedOn: TechArray,
                Part: mergedArray,
                DeviceType: selectDeviceId,
                RepairedItemNote: RepairNotes,
            },
            ...(workedonflag == 0 && { billableFlag: BillableFlag }),
            techPointsAgreeFlag: TechPointsAgreeFlag
        });
        setLoading(true)
        await ApiPostCall("/tickets/repair-tag-popup", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = result;
                if (fromDelete) {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Part Deleted Successfully"} />);
                    setTimeout(() => {
                        setLoading(false);
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1500);
                    return;
                }
                setConfirmationModal(false)
                setLoading(false)
                if (responseRs == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Data Added Successfully"} />);
                    setTimeout(function () {
                        if (workedonflag == 0) {
                            navigate('/manage-tickets')
                        } else {
                            navigate('/school-tickets')
                        }
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }

    async function GetSelectedTechnician() {
        await ApiGetCall(`/tickets/who-worked-on?userId=${LogInUserID}&ticketId=${TicketId}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.response == "success") {
                    const extractedArray = responseRs.msg.map(item => ({ tech_id: item.id, TechEmail: item.email }))
                    setSelectedTechnician(...selectedTechnician, extractedArray)
                }
            }
        })
    }
    async function GetTicketDataByID() {
        setLoading(true)
        await ApiGetCall(`/tickets/by-id?ticketId=${TicketId}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                var sugdata = responseRs.ticket;
                setLoading(false);
                if (responseRs.response == "success") {
                    setRepairSectionAddUpdateFlag(sugdata?.repair_section_add_update_flag)
                    setReworkTicketWhoWorkOn(sugdata?.rework_ticket_who_work_on)
                    setTicketSerialNum({
                        ...TicketSerialNum, SerialNum: sugdata.inventory_management.serial_number, TicketNum: sugdata.ticket_num, TicketID: sugdata.id, Userid: sugdata?.student?.id,
                        ActiveCoverage: sugdata.active_coverage_type, ActiveCoverageColor: sugdata.active_coverage_type_color
                    })
                    setInventoryId(sugdata?.inventory_id)
                    if (sugdata?.student != null) {
                        setUserName((sugdata?.student?.device_user_first_name || '') + ' ' + (sugdata?.student?.device_user_middle_name || "") + ' ' + (sugdata?.student?.device_user_last_name || ''))
                    }
                    setMarkasRepair(sugdata.mark_as_rework)
                    reworkFlagRef.current = sugdata.mark_as_rework
                    setReworkFlag(sugdata.rework_status)
                    setTicketStatus(sugdata.status)
                    if (sugdata.ticket_repair_log.length != 0) {
                        setTicketData({ ...TicketData, partDeleteFlag: sugdata.ticket_ussed_in_invoice_flag, RepairCharge: sugdata.ticket_repair_log[0]?.price })
                        setRepairNotes(sugdata.ticket_repair_log[0]?.repaired_item)
                        setOriginalDeviceType(sugdata.ticket_repair_log[0]?.device_type?.id);
                        setSelectDamageId(sugdata.ticket_repair_log[0]?.damage_types?.id)
                        setSelectDeviceId(sugdata.ticket_repair_log[0]?.device_type?.id)
                        setDeviceTypeCode(sugdata.ticket_repair_log[0]?.device_type?.device_type_code);
                        setSelectedDiscountFlag(sugdata.ticket_repair_log[0]?.device_type?.discount_for_repair_type);
                        setUnderWarrantyChecked(sugdata.ticket_repair_log[0]?.device_type?.under_warranty);
                        setShowUnderWarranty(sugdata.ticket_repair_log[0]?.device_type?.under_warranty == 1 ? true : false);
                    } else {
                        setTicketData({ ...TicketData, partDeleteFlag: sugdata.ticket_ussed_in_invoice_flag, RepairCharge: '' })
                        setOriginalDeviceType(0)
                        setSelectDamageId(0)
                        setSelectDeviceId(0)
                        setDeviceTypeCode(0);
                        setRepairNotes('')
                    }
                    if (sugdata.ticket_attachments.length != 0) {
                        setOriginalParts(sugdata.ticket_attachments)
                        const savedParts = sugdata.ticket_attachments.map(p => ({
                            id: p.part_id,
                            partId: `hdnPartId_${p.part_id}`,
                            variantPrice: `PartsPrice_${p.part_id}`,
                            notesId: `NotesId_${p.part_id}`,
                            title: p.part_name,
                            flag: p.part_flag == 1 ? 'masterColorStatus' : 'schoolColorStatus',
                            part_flag: p.part_flag,
                            variantPriceValue: Number(p.part_price || 0),
                            originalPrice: Number(p.original_price || 0),
                            warrantyCheckbox: p.is_warranty_checkbox == 1,
                            qty: p.quantity,
                            building: p.building,
                            building_part: [],
                            netsuite_internal_sku: p.netsuite_internal_sku,
                            notes: p.part_note,
                            createdBy: p.user_name,
                            partCoveredBy: p.part_covered_by,
                            building_id: p.building_id,
                            addUpdateFlag: 1,
                            price_correction_reason: p?.price_correction_reason,
                            isPriceLocked: [PriceReasonMap.ZeroVal, PriceReasonMap.ManualVal]?.includes(p?.price_correction_reason)
                        }));
                        const sortedParts = doSort(savedParts, 'variantPriceValue')
                        setTicketParts(sortedParts);
                    } else {
                        setOriginalParts([])
                        setTicketParts([]);
                    }
                    if (sugdata.status == 'Repair Finished') {
                        setRepairFinished(true)
                    }
                    setNumberOfClaim(responseRs?.parental_details?.numberof_claim)
                    setBillableFlag(sugdata?.chargeability);
                    setEnrollmentHistory(responseRs?.parental_details?.enrollment_history)
                    setDeviceModelState({
                        deviceModel: responseRs?.ticket?.inventory_management?.device_model?.name ?? "",
                        deviceManufacturer: responseRs?.ticket?.inventory_management?.device_manufacturer,
                        isApproveModel: responseRs?.ticket?.inventory_management?.device_model?.status == 1 && responseRs?.ticket?.inventory_management?.device_model?.manufacturer_id || responseRs?.ticket?.is_approved_manufacturer
                    })
                }
                setGetDataStored(responseRs?.ticket)
            }
        });
    }
    async function deletePart(partId) {
        var deletebuildingid = deletepartbuildingid;
        if (deletebuildingid == undefined || deletebuildingid == null) {
            deletebuildingid = 0;
        }

        const remainingParts = applyPricingRule(ticketParts?.filter(part => part.id !== partId), selectedDiscountFlag, null) || [];

        var raw = JSON.stringify({
            ticketId: TicketId,
            partId: partId,
            batchId: deletebuildingid
        });
        setLoading(true);
        await ApiPostCall("/parts/remove-attached", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = result;
                setDeletePopup(false);
                if (responseRs == "success") {
                    setTicketParts(remainingParts);
                    if (remainingParts.length > 0) {
                        SaveRepairParts(null, true, remainingParts);
                    } else {
                        setNewAlerts(<AlertsComp show={true} variant="success" msg={"Part Deleted Successfully"} />);
                        setTimeout(() => {
                            setLoading(false);
                            setNewAlerts(<AlertsComp show={false} />)
                        }, 1500);
                    }
                } else if (responseRs == "error") {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={"Unable to delete this part. It is associated with an existing invoice"} />);
                    setTimeout(() => {
                        setLoading(false);
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setLoading(false);
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }
    function handleRepairFinished(event) {
        setRepairFinished(event.target.checked);
    }
    function handleMarkasCloseTicket(event) {
        setMarkasCloseTicket(event.target.checked);
    }
    async function GetAllDeviceType() {
        await ApiGetCall("/devices/types/all").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setDeviceTypes(responseRs);
            }
        });
    }
    async function GetAllDamangeType() {
        await ApiGetCall("/tickets/damage-types").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setDamangeTyppe(responseRs);
            }
        });
    }
    function handleKeyDown(event) {
        const searchValue = event.target.value.trim();
        if (searchValue !== "" && (event.key === "Enter" || event.keyCode === 13)) {
            event.preventDefault();
            GetRepairParts(searchValue)
            return false;
        }
    }
    async function GetTechniciansBySchoolLocationData(searchString) {
        setTechnicianData(prevState => ({ ...prevState, loader: true }));
        if (searchString?.trim() == "") {
            searchString = null;
        } else {
            searchString = searchString?.trim();
        }
        setShowSuggestionForWhoWorkOn('');
        typewatch(async function () {
            await ApiGetCall(`${adminCallNode}/technicians/by-school-location?schoolId=${schoolIdForAdmin}&search=${searchString}&userId=${LogInUserID}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs.response == "success") {
                        setTechnicianData(prevState => ({ ...prevState, data: responseRs.msg, loader: false }));
                    }
                }
            })
        }, 500);
    }
    function SetWhoWorkOnValue(sugData) {
        const tech_id = sugData.tech_id;
        const TechEmail = sugData.tech_email;

        setSelectedTechnician((prev) =>
            prev.some(item => item.tech_id === tech_id)
                ? prev.filter(item => item.tech_id !== tech_id)
                : [...prev, { tech_id, TechEmail }]
        );
    }
    function saveDetailsCall() {
        var isFormValid = CheckValidation({ formID: 'validationClass' });
        var isPartsValid = CheckValidation({ formID: 'partValidation' });
        if (workedonflag == 1) {
            if (DeviceTypeCode == 0 || DeviceTypeCode == undefined || DeviceTypeCode == null) {
                setRepairTypeMsg("*required");
                isFormValid = false;
            } else {
                setRepairTypeMsg("");
            }
        } else {
            if (selectDamageId == 0 || selectDamageId == undefined || selectDamageId == null) {
                setRepairTypeMsg("*required");
                isFormValid = false;
            } else {
                setRepairTypeMsg("");
            }
        }
        if (workedonflag == 1) {
            if (ReworkFlag) {
                if (MarkasRepair == 0) {
                    setReworkMsg('*required');
                    isFormValid = false;
                }
            }
        }
        if (!isFormValid || !isPartsValid) return;
        setConfirmationModal(true)
    }
    function AddNewRow(responseRs) {
        const idExists = ticketParts.some(item => item.id === responseRs.id);
        if (!idExists) {
            var warranty = null;
            if (underWarrantyChecked == 1 && workedonflag == 1) {
                warranty = true;
            } else {
                warranty = false;
            }
            const newData = {
                id: responseRs.id,
                partId: `hdnPartId_${responseRs.id}`,
                variantPrice: `PartsPrice_${responseRs.id}`,
                notesId: `NotesId_${responseRs.id}`,
                flag: responseRs.flag,
                title: responseRs.title,
                variantPriceValue: responseRs.variant_price,
                originalPrice: responseRs.variant_price,
                warrantyCheckbox: warranty,
                qty: responseRs.quantity,
                building: responseRs.building,
                building_part: responseRs.building_part,
                netsuite_internal_sku: responseRs.netsuite_internal_sku,
                notes: '',
                createdBy: null,
                partCoveredBy: null,
                building_id: null,
                addUpdateFlag: 0,
                price_correction_reason: PriceReasonMap.NoChangesVal
            };
            handlePriceCalculation([...ticketParts, newData]);
        }
        setLoading(false);
    }

    function handleRepairTypeChange(devicetypeid, underwarranty, discountRepairTypeFlag, deviceTypeCode) {
        setLoading(true);
        const isUnderWarranty = underwarranty == 1 ? true : false;

        setSelectDeviceId(devicetypeid);
        setDeviceTypeCode(deviceTypeCode);
        setShowUnderWarranty(isUnderWarranty);
        setUnderWarrantyChecked(underwarranty);
        setSelectedDiscountFlag(discountRepairTypeFlag);

        const updated = (ticketParts || [])?.map(item => ({
            ...item,
            warrantyCheckbox: item.addUpdateFlag == 0 && isUnderWarranty
        }));
        setTimeout(() => {
            handlePriceCalculation(updated, discountRepairTypeFlag);
            setLoading(false);
        }, 500);
    }
    function handleReworkChange(flag) {
        reworkFlagRef.current = flag;
        if (!ticketParts.length) return;
        setLoading(true);
        setTimeout(() => {
            const updatedVData = ticketParts.map(item => {
                if (flag == 1 && item.addUpdateFlag == 0) return { ...item, warrantyCheckbox: true };
                return { ...item, warrantyCheckbox: false };
            });
            handlePriceCalculation(updatedVData);
            setLoading(false);
        }, 500);
    }
    const handleCheckboxChange = (partId, e) => {
        setLoading(true);
        const allZeroBefore = ticketParts.every(p => Number(p?.variantPriceValue) === 0);
        var checked = e.target.checked;
        setTimeout(() => {
            setTicketParts(prev => {
                const updatedVData = prev.map(item => item.id === partId
                    ? { ...item, warrantyCheckbox: checked }
                    : item
                );
                return applyPricingRule(updatedVData, selectedDiscountFlag, allZeroBefore ? partId : null);
            });
            setLoading(false)
        }, 500);
    };
    const handlePartCostChange = (e, partId) => {
        let value = e.target.value;
        value = value.replace(/^0+/, '');
        if (!value) {
            value = '0';
        }
        const updatedVData = ticketParts.map(item => {
            if (item.id == partId) {
                return {
                    ...item,
                    variantPriceValue: value,
                    price_correction_reason: PriceReasonMap.ManualVal
                };
            }
            return item;
        });
        setTicketParts(updatedVData);
    };
    const handleBuildingChange = (e, partId) => {
        const value = e.target.value;
        const updatedVData = ticketParts.map(item => {
            if (item.id == partId) {
                return { ...item, building: value };
            }
            return item;
        });
        setTicketParts(updatedVData);
    }

    const handlePriceCalculation = (ticketPartList = null, repairTypeDiscpuntFlag = null) => {
        const isList = Array.isArray(ticketPartList);
        const list = isList ? ticketPartList : ticketParts;
        const discountFlag = repairTypeDiscpuntFlag ?? selectedDiscountFlag;
        const reCalculated = applyPricingRule(list, discountFlag, null);
        setTicketParts(reCalculated);
    };

    const handlePriceOnBlur = (e) => {
        const currentValue = e.target.value;
        if (currentValue === priceOnFocusRef.current) return;
        priceOnFocusRef.current = null;
        setLoading(true);
        setTimeout(() => {
            handlePriceCalculation();
            setLoading(false)
        }, 500);
    }

    function renderNewPart(responseRs) {
        return (
            <>
                <div className="row RowClass pt-2" id={`MainRow_${responseRs.id}`}>
                    <input type="hidden" id={responseRs.partId} value={responseRs.id} />
                    <div className={`col-md-11 font-14 ${responseRs.flag || ''} `}>
                        <label className="">
                            {responseRs.title}
                        </label>
                        {` (${responseRs.flag === 'schoolColorStatus' ? organization_part : 'Master Part'})`}
                    </div>
                    <div className="col-md-1">
                        <img
                            src="/images/CancelIcon.svg"
                            title="Delete Part"
                            className="img-fluid cursor-pointer"
                            onClick={() => handleDelete(`MainRow_${responseRs.id}`)}
                        />
                    </div>
                    {workedonflag == 1 &&
                        <div className="row pt-2">
                            <div className="col-md-3 FormLabel fw-600"> NetSuite SKU</div>
                            <div className='col-md-9'>{responseRs.netsuite_internal_sku || '-'}</div>
                        </div>
                    }
                    {workedonflag == 0 && responseRs.flag === 'schoolColorStatus' &&
                        <div className="col-md-12 row pt-2">
                            <div className="col-md-3 mt-2 FormLabel fw-600">Building<label className='redText'>*</label></div>
                            <div className="col-md-6 ps-3">
                                <select required onChange={(e) => handleBuildingChange(e, responseRs.id)}>
                                    {responseRs.building_part.length != 0 && (
                                        <option value="0">Select Building</option>
                                    )}
                                    {responseRs.building_part.map((building, i) => {
                                        return <option value={building.building_id} key={i}>{building?.building_details?.name}</option>
                                    })}
                                    {responseRs.building_part.length == 0 &&
                                        <option value="AtSchool">At {organization}</option>
                                    }
                                </select>
                                <span className="form-text invalid-feedback"> *required </span>
                            </div>
                        </div>
                    }
                    {workedonflag == 1 &&
                        <>
                            <div className="row pt-2">
                                <div className="col-md-2 FormLabel fw-600 text-nowrap">Prices : </div>
                                <div className='col-md-10'>
                                    $ {responseRs.originalPrice} (Original) {SchoolCustomPriceParts.customPricingParts && SchoolCustomPriceParts.customPricingParts[responseRs.id] && <>, $ {SchoolCustomPriceParts.customPricingParts[responseRs.id]} (Custom)</>}
                                </div>
                            </div>
                            {/* <div className='row pt-2'>
                                <div className="col-md-6">
                                    <div className='row'>
                                        <label className=' col-md-6 FormLabel fw-600'>Original Price : </label>
                                        {" "}
                                    </div>
                                </div>
                                (
                                <div className="col-md-6">
                                    <div className='row'>
                                        <label className=' col-md-6 FormLabel fw-600'>Custom Price :</label>
                                        {" "}
                                    </div>
                                </div>
                                )}
                            </div> */}
                        </>
                    }
                    <div className="col-12 py-2 row">
                        <div className="col-12 row pe-0 ">
                            <div className={`col-md-6 mt-2 FormLabel fw-600 ${workedonflag != 1 ? '' : savedBillingColorMap[responseRs?.price_correction_reason] || ''}`}>Part Price<label className='redText'>*</label></div>
                            <div className="col-md-6 px-0 ">
                                <div className="input-group">
                                    <span className="input-group-text">$</span>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        className="form-control"
                                        name="PartsPrice"
                                        id={`PartsPrice_${responseRs.id}`}
                                        value={responseRs.variantPriceValue}
                                        required step="any"
                                        onChange={(e) => handlePartCostChange(e, responseRs.id)}
                                        onBlur={handlePriceOnBlur}
                                        onFocus={(e) => handleOnFocusChange(priceOnFocusRef, e.target.value)}
                                        onKeyDown={(e) => {
                                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        min={0}
                                    />
                                    <span className="form-text invalid-feedback"> *required </span>
                                </div>
                            </div>
                        </div>

                        {showUnderWarranty && workedonflag == 1 && (
                            <div className="col-12 text-end row py-1">
                                <span>
                                    <input
                                        className="form-check-input mt-1 cursor-pointer"
                                        type="checkbox"
                                        id={`WarrantyCheckbox_${responseRs.id}`}
                                        checked={responseRs.warrantyCheckbox}
                                        onChange={(e) => handleCheckboxChange(responseRs.id, e)}
                                    /> (Under Warranty)
                                </span>
                            </div>
                        )}
                        {responseRs.flag === 'schoolColorStatus' ?
                            <div className="col-md-12 row pe-0 pt-2">
                                <div className="col-md-6 mt-2 FormLabel fw-600">Available Qty</div>
                                <div className="col-md-6 px-0">
                                    <input type="text" autoComplete="off" name="Quanitty" className="form-control text-center"
                                        value={responseRs.qty} disabled step="any" />
                                </div>
                            </div>
                            : <></>}
                    </div>
                    <div className="row">
                        <div className="col-md-3 FormLabel fw-600"> Notes</div>
                        <div className='col-md-9'><textarea className="form-control " rows={1} id={`NotesId_${responseRs.id}`}></textarea> </div>
                    </div>
                </div>
                <img src="/images/HorizontalLine.svg" className="img-fluid w-100 my-2 postclass" />
            </>
        );
    }

    function renderSavedPart(item) {
        return (
            <div className="row" key={item.id} partId={item.id}>
                <div className='col-11'>
                    <div className="row align-items-center p-1">
                        <div className='col-md'>
                            <b>Part Name : </b>
                        </div>
                        <div className={`col-md ${partCoveredColorMap[item.partCoveredBy] || ''}`}>
                            <span>{item.title + ' ' + '(' + (item.part_flag == 1 ? 'Master Part' : organization_part) + ')'}</span>
                        </div>
                    </div>
                    {workedonflag == 1 &&
                        <div className="row align-items-center p-1">
                            <div className='col-md'>
                                <b>NetSuite SKU : </b>
                            </div>
                            <div className="col px-0">
                                <span>
                                    {item.netsuite_internal_sku || '-'}
                                </span>
                            </div>
                        </div>
                    }
                    <div className="row align-items-center p-1">
                        <div className='col'>
                            <b>Building : </b>
                        </div>
                        <div className="col px-0">
                            <span className='text-break'>
                                {item.building ? item.building?.name : item.part_flag == 1 ? '-' : 'At School'}
                            </span>
                        </div>
                    </div>
                    <div className="row align-items-center p-1">
                        <div className='col'>
                            <b>Created By : </b>
                        </div>
                        <div className="col px-0">
                            <span>
                                {item.createdBy == "null" || item.createdBy == "" || item.createdBy == null ? (
                                    <>-</>
                                ) : (
                                    <>{item.createdBy}</>
                                )}
                            </span>
                        </div>

                    </div>
                    {item.part_flag != 1 && (
                        <div className="row align-items-center p-1">
                            <div className='col'>
                                <b>Quantity : </b>
                            </div>
                            <div className="col px-0">
                                <span>
                                    {item.qty == null ? (
                                        <>0</>
                                    ) : (
                                        <>{item.qty}</>
                                    )}
                                </span>
                            </div>
                        </div>
                    )}
                    {workedonflag == 1 &&
                        <>
                            <div className="row p-1">
                                <b className="col-md-6 text-nowrap">Prices : </b>
                                <div className='col-md-6'>
                                    $ {item?.originalPrice || "0"} (Original) <br /> {SchoolCustomPriceParts.customPricingParts && SchoolCustomPriceParts.customPricingParts[item.id] && <> $ {SchoolCustomPriceParts.customPricingParts[item.id]} (Custom)</>}
                                </div>
                            </div>
                        </>
                    }
                    <div className="row align-items-center p-1">
                        <div className={`col pe-0 ${workedonflag != 1 ? '' : savedBillingColorMap[item?.price_correction_reason] || ''}`}>
                            <b>Part Price : </b>
                        </div>
                        <div className="col px-0">
                            <div className="input-group">
                                <span className="input-group-text">$</span>
                                {billingflag != 1 ?
                                    <input className="form-control" autocomplete="off" type="number" name="notes" placeholder="Part Price"
                                        id={item.variantPrice} value={item?.variantPriceValue}
                                        onChange={(e) => handlePartCostChange(e, item.id)}
                                        min={0} step="any"
                                        onBlur={handlePriceOnBlur}
                                        onFocus={(e) => handleOnFocusChange(priceOnFocusRef, e.target.value)}
                                        onKeyDown={(e) => {
                                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    :
                                    <input className="form-control" autocomplete="off" type="number" name="notes" placeholder="Part Price"
                                        id={item.variantPrice} value={item.variantPriceValue} min={0} disabled step="any" />
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row p-1 align-items-center">
                        <div className="col pe-0">
                            <b>Notes : </b>{" "}
                        </div>
                        <div className="col px-0">
                            <span>
                                <input className="form-control" autocomplete="off" type="text" name="notes" placeholder="Notes"
                                    id={item.notesId} defaultValue={item.notes} />
                            </span>
                        </div>
                    </div>
                </div>
                <div className='col-1 pe-0'>
                    {billingflag != 1 && (
                        <div className='col-12 text-end pt-2'>
                            <img src="/images/DeleteIcon.svg" title="Delete Part" className="img-fluid cursor-pointer"
                                onClick={() => { setDeletePopup(true); setdeletepartid(item.id); setdeletepartbuildingid(item.building_id) }}
                            />
                        </div>
                    )}
                </div>
                <div className='col-md-12 text-center'><hr className='m-2' /></div>
            </div>
        )
    }

    function renderPartRow(part) {
        if (part.addUpdateFlag === 0) return renderNewPart(part);
        if (part.addUpdateFlag === 1) return renderSavedPart(part);
        return null;
    }

    return (
        <>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row align-items-center pe-0'>
                <div className='col-5'>
                    <h1 className="PageHeading mb-0">Repair details for the device</h1>
                </div>
                <div className='col-7 text-end h5 mb-0'>
                    {(show_device_complete_club || ExcludeVarAccess) ?
                        FlagForParental == 1 ? (
                            EnrollmentHistory?.enrollment_status == 2 &&
                            <div className='blueText fs-6 fw-600 mb-2'>{dcc_module_text} Expired</div>
                        ) : (
                            <></>
                        ) : null}
                    {FlagForParental == 1 ?
                        (
                            <>
                                <span className={`${NumberOfClaim > 1 ? 'redText fw-600' : ''}`}>No of Claim : <b>{NumberOfClaim || '0'}</b></span>
                                <b>,&nbsp;</b>
                            </>
                        ) : (
                            <></>
                        )}
                    &nbsp;
                    <span>{UserName ? <b><u className='cursor-pointer' onClick={(e) => setUserModal(true)}>{UserName}</u></b> : <></>}</span>
                </div>
            </div >
            <div className="GridBox px-3 pb-3 mt-3 pt-2 h-100" >
                <div className='row pb-2 align-items-center'>
                    <div className='col-md-6 d-flex align-items-center'>
                        <span className='ps-2'><b>Who Worked On:  </b></span>
                        {workedonflag == 1 && WhoWorkedOnAccess ?
                            <div className='ms-3 col-md-7'>
                                <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                                    <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search"></i></div>
                                    <input className="form-control" autoComplete="off" type="text" placeholder="Search"
                                        value={SearchForWhoWorkOn}
                                        onChange={(e) => { setSearchForWhoWorkOn(e.target.value); GetTechniciansBySchoolLocationData(e.target.value) }}
                                        onKeyUp={(e) => { GetTechniciansBySchoolLocationData(e.target.value); setSearchForWhoWorkOn(e.target.value) }}
                                    />
                                    <div className={`SuggestionBoxDiv ${ShowSuggestionForWhoWorkOn}`} ref={suggestionBoxWhoWorkOnRef} style={{ zIndex: 3 }}>
                                        {TechnicianData.loader ?
                                            <div className='row'>
                                                <div className="col-12 text-center pt-2">
                                                    <img src="/images/loder.svg" className="" style={{ width: "30px" }} />
                                                </div>
                                            </div>
                                            : TechnicianData.data.length > 0 ?
                                                TechnicianData.data.map((sugData) => (
                                                    <div className="col-md-12 justify-content-between brdr-Btm font-14" style={{ padding: "4px 10px", cursor: 'default' }}>
                                                        <div className='d-flex align-items-center justify-content-start gap-2' style={{ cursor: 'default' }}>
                                                            <input
                                                                type="checkbox"
                                                                className='form-check-input m-0 cursor-pointer'
                                                                checked={selectedTechnician?.some(item => item.tech_id === sugData?.tech_id)}
                                                                onChange={(e) => SetWhoWorkOnValue(sugData)}
                                                            />
                                                            <b className='text-capitalize'>{sugData?.tech_name}</b>
                                                        </div>
                                                        <div className='text-end' style={{ cursor: 'default' }}>{sugData?.tech_email}</div>
                                                    </div>
                                                ))
                                                : <div className="col-12 text-center" key="no-record">
                                                    <label>No Record Found</label>
                                                </div>
                                        }
                                    </div>
                                </form>
                            </div>
                            : <span className='ps-3'>{loggedinemailid}</span>
                        }
                    </div>
                    <div className='col-md-6 ps-0 text-end align-items-center'>
                        <b>Device:</b> <u className='cursor-pointer' onClick={(e) => setDevicePopup(true)}>{TicketSerialNum.SerialNum}</u>&nbsp; ,<b>Ticket #: </b> <u className='cursor-pointer' onClick={(e) => setisTicketDetailspopup(true)}>{TicketSerialNum.TicketNum}</u>
                        &nbsp; <br /><b>Active Coverage: </b> <u className='cursor-pointer' style={{ color: TicketSerialNum.ActiveCoverageColor }}>{TicketSerialNum.ActiveCoverage ?? '-'}</u>
                    </div>
                </div>

                {selectedTechnician?.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        {selectedTechnician?.map((item, index) => (
                            <label
                                className="border rounded-pill py-1 px-3 d-flex align-items-center"
                                key={index}
                            >
                                {item.TechEmail}
                                {WhoWorkedOnAccess && (
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ps-2 cursor-pointer"
                                        onClick={() => {
                                            setSelectedTechnician((prev) =>
                                                prev.filter((tech) => tech.tech_id !== item.tech_id)
                                            );
                                        }}
                                    />
                                )}
                            </label>
                        ))}
                    </div>
                )}

                <div className="row">
                    {/* Ticket Details Div */}
                    <div className="col-lg-7 pl-2 mt-2">
                        <div className="greyBox parent" id='validationClass'>
                            {workedonflag == 1 && ExcludeVarAccess ?
                                <Accordion activeKey={activeKey} onSelect={setActiveKey} className='mb-3'>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>View Service Profile Details</Accordion.Header>
                                        <Accordion.Body>
                                            <SchoolProfileInfo schoolId={schoolIdForAdmin} />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                : null
                            }

                            <div className='row mt-2'>
                                <div className="col-md-3 pe-0 mb-2 FormLabel fw-600">Repair Type<label className='redText'>*</label> :</div>
                                <div className='col-md-9 row'>
                                    {workedonflag == 1 ?
                                        <>
                                            {DeviceTypes.map((devicetype, j) => {
                                                return (
                                                    <div className="col-md-6 pb-1 px-0 d-flex" key={devicetype.id}>
                                                        <input
                                                            className="form-check-input repairtechIssueClass me-2"
                                                            checked={selectDeviceId === devicetype.id}
                                                            type="radio"
                                                            name="LoanerDevice"
                                                            onChange={() => handleRepairTypeChange(devicetype.id, devicetype.under_warranty, devicetype?.discount_for_repair_type, devicetype?.device_type_code)}
                                                        />
                                                        <label className="form-check-label font-13">{devicetype.type}</label>
                                                    </div>
                                                );
                                            })}
                                        </>
                                        :
                                        <>
                                            {DamangeTyppe.map((damagetype, j) => {
                                                return (
                                                    <div className="col-md-6 pb-1" key={damagetype.id}>
                                                        <input
                                                            className="form-check-input repairtechIssueClass me-2"
                                                            checked={selectDamageId === damagetype.id}
                                                            type="radio"
                                                            name="LoanerDevice"
                                                            onChange={() => setSelectDamageId(damagetype.id)}
                                                        />
                                                        <label className="form-check-label font-13">{damagetype.damage_type}</label>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    }
                                </div>
                                <span className='Emailinvalid'>{RepairTypeMsg}</span>
                            </div>
                            <div className="col-12 mt-2">
                                <div className="row align-items-center">
                                    <div className="col-md-3 FormLabel fw-600">Repair Notes<label className='redText'>*</label> :</div>
                                    <div className="col-md-9 ps-0">
                                        <textarea type="textarea" rows={2} autoComplete="off" name="RepairedNm" className="form-control" required value={RepairNotes} onChange={(e) => setRepairNotes(e.target.value)} />
                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {(show_device_complete_club && ExcludeVarAccess) ?
                                <div className='d-flex mt-2 FormLabel fw-600'>Has {dcc_module_text}? &nbsp;
                                    <label className='fw-600 ps-2' style={{ color: 'var(--primary-color)' }}>
                                        {FlagForParental == 1 ?
                                            EnrollmentHistory?.enrollment_status == 2 ?
                                                (<>Yes <span className='blueText'>(Club expired)</span></>)
                                                : 'Yes'
                                            : 'No'}
                                    </label>
                                </div>
                                : null
                            }
                            {workedonflag == 1 && (
                                <>
                                    <div className='col-12 d-flex mt-2'>
                                        <b className='FormLabel fw-600'> Is this a repeat of the previous ticket's issue?</b>
                                        <div className='ps-3 d-flex align-items-center'>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name='billable'
                                                    onChange={(e) => { setMarkasRepair(1); handleReworkChange(1) }}
                                                    checked={MarkasRepair == 1}
                                                />
                                                <label className="form-check-label">Yes</label>
                                            </div>
                                            <div className="form-check ms-5">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name='billable'
                                                    onChange={(e) => { setMarkasRepair(2); handleReworkChange(2) }}
                                                    checked={MarkasRepair == 2}
                                                />
                                                <label className="form-check-label">No</label>
                                            </div>
                                            <img src="/images/InfoBtn.svg" title="Show Details" className="ps-3 cursor-pointer" height='16px'
                                                onClick={(e) => setReworkModal(true)} />
                                        </div>
                                    </div>
                                    <span className='Emailinvalid'>{ReworkMsg}</span>
                                </>
                            )}

                            {workedonflag == 0 && (
                                <div className='col-12 d-flex mt-2'>
                                    <b className='FormLabel fw-600'> Would you like to mark this ticket as billable to the {student?.toLowerCase()}?</b>
                                    <div className='ps-3 d-flex align-items-center'>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name='billable'
                                                onChange={(e) => setBillableFlag(1)}
                                                checked={BillableFlag == 1}
                                            />
                                            <label className="form-check-label">Yes</label>
                                        </div>
                                        <div className="form-check ms-5">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name='billable'
                                                onChange={(e) => setBillableFlag(0)}
                                                checked={BillableFlag != 1}
                                            />
                                            <label className="form-check-label">No</label>
                                        </div>
                                    </div>
                                </div>)}

                        </div>
                        {/* school parts and master parts inputs */}

                    </div>
                    {/* Attach Parts Div */}
                    <div className="col-lg-5 pl-2 mt-2">
                        <div className="greyBox parent" id='partValidation'>
                            <div className="d-flex col-md-12">
                                <h5 className="fw-600 mb-0">Attached Parts</h5>
                                <CustomFieldInfoIcon bodyLabel={
                                    <>
                                        <div className='d-flex flex-column justify-content-between gap-2 text-nowrap font-13'>
                                            <label className='highlight-part'>*Warranty</label>
                                            <label className='redText'>*Rework</label>
                                            <label className='blueText'>*Rework & Warranty</label>
                                            {workedonflag == 1 && (
                                                <>
                                                    <label className='billingOrangeText'>*Custom Prices</label>
                                                    <label className='billingPurpleText'>*Halved Prices</label>
                                                    <label className='billingCyanText'>*Custom & Halved Prices</label>
                                                </>
                                            )}
                                        </div>
                                    </>
                                } />
                            </div>
                            <hr />
                            {billingflag != 1 && (
                                <div className="col-md-12 ">
                                    <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                                        <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon">
                                            <i className="bi bi-search"></i>
                                        </div>
                                        <input id="partsSearchInput" className="form-control" autoComplete="off" type="text"
                                            placeholder="Search the necessary repair part with the ticket"
                                            value={SearchForParts}
                                            onFocus={(e) => {
                                                setSearchForParts(e.target.value);
                                                setSuggestionBoxArray([]);
                                                if (deviceModelState.isApproveModel) {
                                                    GetRepairParts(e.target.value);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key == 'Tab') {
                                                    setTicketData({ ...TicketData, ShowSuggestion: 'd-none' });
                                                }
                                                handleKeyDown(e); setSuggestionBoxArray([])
                                            }}
                                            onChange={(e) => { setSearchForParts(e.target.value); setSuggestionBoxArray([]) }}
                                            onKeyUp={(e) => {
                                                GetRepairParts(e.target.value); setSearchForParts(e.target.value); setSuggestionBoxArray([])
                                            }}
                                        />
                                        <div className={`SuggestionBoxDiv ${TicketData.ShowSuggestion}`} style={{ zIndex: 1, height: '480px' }} ref={suggestionBoxRef}>
                                            {RepairLoder == true ?
                                                <div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div>
                                                :
                                                SuggestionBoxArray
                                            }
                                        </div>
                                    </form>
                                </div>
                            )}

                            <div className="scrollbar-css-repairdetails row pt-2 overflow-y-auto">
                                {ticketParts?.length ? (
                                    ticketParts.map(part => (
                                        <React.Fragment key={part.id || part.part_id}>
                                            {renderPartRow(part)}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <div className="col-12 text-center">
                                        <label>
                                            {deviceModelState.isApproveModel ? (
                                                <>
                                                    Parts list filtered for <b>{deviceModelState.deviceManufacturer}</b> <b>{deviceModelState.deviceModel}</b>.
                                                </>
                                            ) : (
                                                "No Record Found"
                                            )}
                                        </label>
                                    </div>

                                )}
                            </div>
                        </div>
                    </div>
                </div >
                {workedonflag == 1 && (
                    <div className="col-md-12 text-center mt-2 py-3 justify-content-center align-items-center">
                        {tabflag == 5 && TicketStatus != 'Repair Billed' ?
                            <div className='d-flex align-items-center justify-content-center'>
                                <input checked className="form-check-input m-0" type="checkbox" name="allSelect" onChange={handleRepairFinished} /><span className='fw-600 ps-3' style={{ fontSize: '17px' }}> Mark as 'Repair Finished'</span>
                            </div> :
                            <div className='d-flex align-items-center justify-content-center'>
                                <input checked={repairFinished} className="form-check-input m-0" type="checkbox" name="allSelect" onChange={handleRepairFinished} /><span className='fw-600 ps-3' style={{ fontSize: '17px' }}> Mark as 'Repair Finished'</span>
                            </div>
                        }
                    </div>
                )}
                {((workedonflag == 0 && ticketTabFlag == 1) || (workedonflag == 0 && ticketTabFlag == 3) || (workedonflag == 0 && ticketTabFlag == 4 &&
                    (TicketStatus != 'Closed' && TicketStatus != "Closed, Sent out for the Payment" && TicketStatus != "Closed, Payment Received" && TicketStatus != "Closed, Pending Payment"))) ?
                    <> <div className='col-12 d-flex align-items-center justify-content-center py-2'>
                        <input checked={MarkasCloseTicket} className="form-check-input m-0" type="checkbox" name="allSelect" onChange={handleMarkasCloseTicket} /><span className='fw-600 ps-3' style={{ fontSize: '17px' }}> Mark as 'Close Ticket'</span>
                    </div></>
                    :
                    <></>}
                <div className='col-12 text-center py-2'>
                    <button className="SaveBtn mt-2" onClick={(e) => saveDetailsCall()}>Save Details</button>
                    <label className="ms-2 cursor-pointer" onClick={(e) => setConfirmationCancelModal(true)}><u>Cancel</u></label>
                </div>
            </div >
            <AlertPopup isshow={ConfirmationModal} img={'/images/greenInfo.svg'}
                headingtext={'Proceed to save?'} text={workedonflag == 1 ?
                    <div className='col-12'>
                        <>
                            {!repairFinished && (
                                <>
                                    <label className='custom-text-danger'>You have not marked this ticket as Repair Finished.</label>
                                    <div className='col-12 pt-2 d-flex align-items-center justify-content-center'>
                                        <input checked={MarkasIncompleteRepair == 1} className="form-check-input m-0" type="checkbox" name="incompleterepair"
                                            onChange={(e) => setMarkasIncompleteRepair(e.target.checked ? 1 : 0)} />
                                        <div className='ps-2'>Incomplete Repair</div>
                                    </div>
                                </>
                            )}
                            {WhoWorkedOnAccess && (
                                <div className='col-12 mt-3'>
                                    {selectedTechnician?.length > 0 ?
                                        <div className=''>
                                            <input checked={TechPointsAgreeFlag == 1} className="form-check-input" type="checkbox" name="techPointsAgreeFlag"
                                                onChange={(e) => setTechPointsAgreeFlag(e.target.checked ? 1 : 0)} />
                                            <span className='ps-2'>Do you want to assign points to the selected technician for this ticket?</span>
                                        </div>
                                        :
                                        <label className='yellow-warning-text'>No technician is selected, so no one will receive points for this ticket</label>
                                    }
                                </div>
                            )}
                        </>
                    </div>
                    : ''} cancelcall={(e) => setConfirmationModal(false)}
                canceltext={"Cancel"} successtext={"Save"}
                successcall={(e) => SaveRepairParts(e)} btntype={'SaveBtn'}
            />

            <AlertPopup isshow={ConfirmationCancelModal} img={'/images/redInfo.svg'}
                headingtext={'Confirm to cancel changes?'} text={''} cancelcall={(e) => setConfirmationCancelModal(false)}
                canceltext={"No"} successtext={"Yes"} successcall={(e) => { workedonflag == 0 ? navigate('/manage-tickets') : navigate('/school-tickets') }}
                btntype={'deleteBtn'} />

            {UserModal == true && (
                <UserDetailsPopup isShow={UserModal} ClosePopup={(e) => setUserModal(false)} userid={TicketSerialNum.Userid} />
            )}

            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deletePopup} size="xl" deletePart={(e) => deletePart(deletepartid)} DeleteShowClose={(e) => setDeletePopup(false)} />
            {isTicketDetailspopup == true && (
                <TicketDetailsPopup isShow={isTicketDetailspopup} ticketid={TicketId} ClosePopup={(e) => setisTicketDetailspopup(false)} />
            )}
            {DevicePopup == true && (
                <DeviceDetailsPopup Showbuttons={1} createticketbutton={false} deviceid={InventoryId} activetab="device" isShow={DevicePopup} ClosePopup={(e) => setDevicePopup(false)} />
            )}
            {ReworkModal == true && (
                <ReworkPopup isShow={ReworkModal} ClosePopup={(e) => setReworkModal(false)} ticketid={TicketId} />
            )}
        </>
    )
}

export default RepairDetails